export default __webpack_public_path__ + "static/renault-megane-1e65de52f0f77961d0be5d3bee4bb05d.jpg";